var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg3Ds = function Svg3Ds(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6.1 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18.1 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.6 10.5 18.1 6h4.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#84BD5A",
    d: "M19.6 19.5c0 .413-.338.75-.75.75H2.35a.75.75 0 0 1-.75-.75V12c0-.412.337-.75.75-.75h16.5c.412 0 .75.338.75.75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.375 14.6H5.35c-.504 0-.474-.75 0-.75h1.834c.366 0 .534.421.264.69l-.995.93c.732-.054 1.307.49 1.307 1.164C7.76 17.37 7.24 18 6.142 18c-.48 0-.953-.198-1.23-.63-.288-.425.33-.833.653-.413.157.203.409.306.678.306.365 0 .725-.157.725-.63 0-.624-.76-.527-1.174-.486-.504.097-.654-.45-.36-.677zM9.008 18c-.198 0-.414-.108-.414-.371v-3.407c0-.215.216-.372.414-.372h1.373c2.74 0 2.68 4.15.054 4.15zm.378-3.418v2.687h.995c1.62 0 1.691-2.687 0-2.687z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.125 14.75c.138-1.164 1.895-1.373 2.723-.737.408.33-.024.851-.384.587-.444-.281-1.452-.413-1.578.21-.162.983 2.447.42 2.405 2.016-.042 1.523-2.249 1.558-3.077.875a.443.443 0 0 1-.084-.588c.156-.155.33-.21.534-.041.492.335 1.758.587 1.847-.265-.077-.887-2.572-.354-2.386-2.057"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M18.85 20.25H4.6V21h14.25c.412 0 .75-.337.75-.75v-.75c0 .413-.338.75-.75.75"
  })));
};
export default Svg3Ds;